<template>
<div id="app">
  <v-app>
    <drawer :drawer.sync="drawer" :menus="menus" :headerBackground="drawerHeaderBackground"></drawer>
    <toolbar :logo="logo" @drawer="toggleDrawer"></toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <console></console>
  </v-app>
</div>
</template>

<script>
import {
  Toolbar,
  Drawer,
  LogoIcons,
  ConsoleNotifier
} from 'luffanet-web-components'
import menus from './helpers/menus'

export default {
  name: 'App',
  components: {
    'toolbar': Toolbar,
    'drawer': Drawer,
    'console': ConsoleNotifier
  },
  data: () => ({
    drawer: false,
    menus: menus,
    logo: LogoIcons.toolbar,
    drawerHeaderBackground: require('./assets/drawer_background.jpg')
  }),
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer
    }
  }
}
</script>

<style>
@import 'vuetify/dist/vuetify.css';
</style>



// WEBPACK FOOTER //
// src/App.vue